import { useTranslation } from 'react-i18next'
import { Button, GenericDialog } from '@/common'
import { useCallback, useEffect, useState } from 'react'
import { CnCodeSelector } from '@/components/CnCodeSelector'
import { useGoodsCodes } from '@/shared/hooks/api/goodsCodes'

function GoodSelectorDialog({
  onClose,
  isOpen,
  productionMethodCode,
  add
}: {
  onClose: () => void
  isOpen: boolean
  add: (goodsCode: string) => void
  productionMethodCode: string | null
}) {
  const [goodsCode, setGoodsCode] = useState<string>('')
  const { t } = useTranslation()

  const { data: goodsCodes, refetch: refetchGoodsCodes } = useGoodsCodes({
    productionMethod: productionMethodCode
  })

  useEffect(() => {
    if (productionMethodCode) {
      refetchGoodsCodes()
    }
  }, [productionMethodCode, refetchGoodsCodes])

  const onAddClick = useCallback(() => {
    add(goodsCode)
    onClose()
  }, [add, onClose, goodsCode])

  const isAddEnabled = Boolean(goodsCode)

  return (
    <GenericDialog
      size="lg"
      close={onClose}
      isOpen={isOpen}
      title={t('productionRoute:goodSelector.title')}
    >
      <div className="flex-col flex mb-6">
        <CnCodeSelector
          label={t('productionRoute:goodSelector.goodsCode.label')}
          cnCode={goodsCode}
          onCnCodeUpdate={setGoodsCode}
          filteredCnCodes={goodsCodes?.map(goodsCode => goodsCode.goodsCode8Digits)}
        />
      </div>
      <footer className="gap-2 flex justify-end">
        <Button variant="neutral" onClick={onClose}>
          {t('common:actions.cancel')}
        </Button>
        <Button disabled={!isAddEnabled} onClick={onAddClick}>
          {t('common:actions.add')}
        </Button>
      </footer>
    </GenericDialog>
  )
}

export default GoodSelectorDialog
